import { Card, Tooltip } from "pepsico-ds";
import ButtonGroupDynamic from "../../common/ButtonGroupDynamic";
import SegmentAttributesAndValues from "../SegmentAttributesAndValues";
import { segmentActionButtons } from "../segmentActionButtons";
import "./segmentCard.scss";

const SegmentCard = ({ segment, segmentType, handleActionClick }) => {
  const { name, population, status, rules, type } = segment;

  return (
    <Card
      className="segment-card-container"
      icon=""
      ellipsis=""
      style={{
        padding: "0px",
        borderRadius: "10px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      <div className="segment-card-container">
        <div className="segment-details">
          <div className="segment-status-type">
            <span
              className={`status ${status === "ENABLED" ? "active" : "inactive"}`}
            >
              {status === "ENABLED" ? "Active" : "Inactive"}
            </span>
            <span className="type">{type}</span>
          </div>
          <h3 className="segment-name">
            {name?.length > 40 ? (
              <Tooltip direction="right" text={name}>
                {name.substring(0, 60)}...
              </Tooltip>
            ) : (
              name
            )}
          </h3>
          <div className="segment-meta">
            {segmentType === "PLATFORM" && (
              <div className="meta-item">
                <span className="meta-label">Id</span>
                <span>{segment?.id}</span>{" "}
              </div>
            )}
            <div className="meta-item">
              <span className="meta-label">Population</span>
              <span>{population ? population.toLocaleString() : "N/A"}</span>{" "}
              {/* Format population with commas */}
            </div>
            <div className="meta-item" style={{ width: "100%" }}>
              <span className="meta-label">Attributes and Values</span>
              <SegmentAttributesAndValues rules={rules} />
            </div>
          </div>

          <div className="button-group-container">
            <ButtonGroupDynamic
              items={segmentActionButtons(
                status,
                segment?.id,
                segmentType,
                handleActionClick
              )}
              spacing="1px"
              size="small"
              variant="control"
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SegmentCard;
